import { buildBackendUrl } from './backend-url';

export const environment = {
  production: true,
  getLanguage: () => {
    let language = localStorage.getItem('language');
    if (!language) {
      language = 'en';
      localStorage.setItem('language', language);
    }
    return language;
  },
  setLanguage: (language: string) => {
    localStorage.setItem('language', language);
  },
  backendUrl: buildBackendUrl(),
  routes: {
    dashboard: '/index/school/dashboard',
    TeacherDashboard: '/index/teacher/dashboard',
    studenthomepage: '/index/student/home',
    payment: '/index/checkout',
    index_journeys: '/index/journeys',
    index_worldCup: '/index/world-cup-prediction',
    index_parent: '/index/homeschooling',
    index_individual: '/index/roadmap/1',
    paymentdetails: '/index/school/payment',
    activitydetails: '/index/activity',
    ProfilePlans: '/index/profile/subscription/3',
    learn2codePrograms: '/code2earn/apply',
    individual_journey: '/index/roadmap/',
  }
};
